import React from 'react';
import { StyledTitleStack, StyledFormStack, StyledHeaderStack, StyledContent, styles } from '../UnlockForm/UnlockForm.styles';
import { TextV2 } from '@withjoy/joykit';
import type { GuestTypes } from '@apps/guest/packages/layout-engine/components/UnlockDialog/UnlockDialog';
import { useFindInviteSuccessController } from './FindInviteSuccessForm.controller';
import { GuestSiteTypographyOverride } from '@apps/guest/components/GuestSiteTypographyOverride/GuestSiteTypographyOverride';
import { body4ToSubHeadingOverride, hed6ToSubHeadingOverride } from '@apps/guest/components/GuestSiteTypographyOverride/GuestSiteTypographyOverride.constants';
import { UnlockSubmitButton } from '../shared/UnlockSubmitButton';

export interface SuccessFormProps {
  eventId: string;
  guest: GuestTypes;
  onDialogClose: () => void;
}

const FindInviteSuccessForm: React.FC<SuccessFormProps> = ({ guest, eventId, onDialogClose }) => {
  const { title, subtitle, submitButtonText, onSubmitHandler, verifying } = useFindInviteSuccessController({ guest, eventId, onDialogClose });

  return (
    <StyledContent __css={styles.content}>
      <StyledHeaderStack>
        <StyledTitleStack>
          <GuestSiteTypographyOverride override={hed6ToSubHeadingOverride}>
            <TextV2 typographyVariant="hed6">{title}</TextV2>
          </GuestSiteTypographyOverride>
          <GuestSiteTypographyOverride override={body4ToSubHeadingOverride}>
            <TextV2 typographyVariant="body4">{subtitle}</TextV2>
          </GuestSiteTypographyOverride>
        </StyledTitleStack>
      </StyledHeaderStack>
      <StyledFormStack
        spacing={6}
        __css={styles.formStack}
      >
        <UnlockSubmitButton
          width={'100%'}
          shape="rounded"
          variant="outline"
          onClick={onSubmitHandler}
          loading={verifying}
        >
          {submitButtonText}
        </UnlockSubmitButton>
      </StyledFormStack>
    </StyledContent>
  );
};

export default FindInviteSuccessForm;
